import { render, staticRenderFns } from "./label-text.vue?vue&type=template&id=a592b8a2&scoped=true"
import script from "./label-text.ts?vue&type=script&lang=ts&external"
export * from "./label-text.ts?vue&type=script&lang=ts&external"
import style0 from "./label-text.less?vue&type=style&index=0&id=a592b8a2&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a592b8a2",
  null
  
)

export default component.exports